// extracted by mini-css-extract-plugin
export default {"topuser_card":"UserSection_topuser_card__fP1Wb","rating":"UserSection_rating__6vsDn","topuser_container":"UserSection_topuser_container__42Ck6"};